import React from 'react';
import dynamic from 'next/dynamic';
import { useIntl } from 'react-intl';
import Frontpage from '@fuww/library/src/Frontpage';
import ArticleLayout from '../News/ArticleLayout';
import Head from '../Head';
import HomeLink from '../HomeLink';
import LinkAndAnchor from '../LinkAndAnchor';
import messages from '../../lib/messages.json';
import loading from '../../lib/loading';
import { getTrendsCategories } from '../../lib/categoryTags';
import { useSiteContext } from '../SiteContext';
import InView from '../InView';

const DynamicCategoryTagsSection = dynamic(() => import(
  '../News/ArticleLayout/CategoryTags'
), {
  ssr: false,
  loading,
});

const Category = dynamic(() => import(
  '../News/NewsList/Categories/NewsCategories'
), {
  ssr: false,
  loading,
});

const Trends = () => {
  const intl = useIntl();
  const { locale } = useSiteContext();
  const { categories, getKeywords } = getTrendsCategories(locale);
  const intro = intl.formatMessage(messages.trendsIntro);

  const TRENDS_NEWS_QUERY_VARIABLES = {
    tagSlugs: getKeywords(),
  };
  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="trends"
      passHref
    >
      {intl.formatMessage(messages.trends)}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intro}
        description={intl.formatMessage(messages.trendsMetaDescription)}
      />
      <Frontpage
        breadcrumbs={breadcrumbs}
        intro={intro}
        mainSection={(
          <ArticleLayout
            featuredVariables={TRENDS_NEWS_QUERY_VARIABLES}
            moreNewsVariables={TRENDS_NEWS_QUERY_VARIABLES}
            categorySection={(
              <InView>
                <DynamicCategoryTagsSection
                  page="trends"
                  categories={categories}
                  bottomCategories={<Category variables={{ id: 27 }} />}
                />
              </InView>
            )}
          />
        )}
      />
    </>
  );
};

export default Trends;
